export const convertGameMakerColourToHex = (colour: number) => {
  const hex = colour.toString(16).padStart(6, "0");
  const r = hex.substring(4, 6);
  const g = hex.substring(2, 4);
  const b = hex.substring(0, 2);

  return `${r}${g}${b}`;
};
